module.exports = __webpack_public_path__ + "static/waluta-c2e2246982c26d9da3cb87f8c5580d78.jpg";